export const styles = (theme) => ({
  topBar: {
    height: '48px',
    background: '#9E9E9E'
  },
  topBarDiv: {
    justifyContent: 'space-between',
    display: 'flex'
  },
  topBarLogo: {
    padding: '2px'
  },
  topBarLogoImg: {
    width: '44px',
    height: '44px'
  },
  topBarMenu: {
    padding: '5px'
  },
  containerRoot: {
    paddingLeft: '6px',
    paddingRight: '6px'
  },
  containerRootAA: {
    paddingLeft: '12px',
    paddingRight: '12px'
  },
  containerRootSubscriber: {
    paddingLeft: '0px',
    paddingRight: '0px'
  },
  containerRootBudgetSubscriber: {
    paddingLeft: '15px',
    paddingRight: '15px'
  },
  beta: {
    color: '#A9A9A9',
    display: 'inline',
    fontSize: '14px',
    marginLeft: '2px'
  },
  paper: {
    padding: '12px',
    boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.25)',
    height: '100%',
    borderRadius: '5px',
    backgroundColor: 'white'
  },
  cardDefault: {
    height: '100%',
    background: '#FFFFFF', /* White */
    boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    padding: '12px',
    [theme.breakpoints.between('xs', 'sm')]: {
      height: '176px',
      paddingTop: '3px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      height: '176px',
      paddingTop: '6px'
    }
  },
  cardHeight: {
    [theme.breakpoints.between('xs', 'sm')]: {
      //height: '352px'
    }
  },
  cardContent: {
    padding: '0px'
  },
  cardTitle: {
    left: '12px',
    top: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000000', /* Black */
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '15px',
      lineHeight: '19px'
    }
  },
  cardInfo: {
    width: '10px',
    height: '10px',
    marginLeft: '1px',
    marginTop: '-12px'
  },
  cardSubTitle: {
    width: '100%',
    left: '12px',
    //marginTop: '4px',
    fontFamily: 'Uni Sans Book Italic',
    //fontStyle: 'italic',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '17px',
    color: '#000000', /* Black */
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px',
      lineHeight: '13px',
      marginTop: '0px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px',
      lineHeight: '13px',
      marginTop: '0px'
    }
  },
  subTitle: {
    width: '50%'
  },
  engagement: {
    display: 'flex',
    //marginTop: '20px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '48px',
    lineHeight: '58px',
    justifyContent: 'center',
    letterSpacing: '-0.5px',
    color: '#00D823', /* Green */
    paddingTop: '13px',
    //minHeight: '130px',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '42px',
      lineHeight: '50px',
      marginTop: '0px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      marginTop: '6px',
      paddingTop: '6px'
    }
  },
  engagementTitle: {
    marginTop: '15px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.1px',
    /* Black */
    color: '#000000',
    [theme.breakpoints.between('md', 'md')]: {
      marginTop: '0px'
    }
  },
  engagementNegative: {
    color: '#F33636 !important' /* Red */
  },
  engagementChartDiv: {
    //display: 'flex',
    justifyContent: 'center',
    marginTop: '2px',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px'
    }
  },
  engagementGuage: {
    margin: '15px auto'
  },
  engagementBackground: {
    /* AccentGray */
    padding: '12px !important',
    background: '#F4F5F6',
    borderRadius: '5px',
    width: '148px',
    //height: '132px',
    // margin: '0 auto',
    marginTop: '30px',
    //minHeight: '130px',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '132px',
      height: '116px',
      marginTop: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      width: '132px',
      height: '96px'
    }
  },
  engagementNetwork: {
    display: 'flex',
    marginTop: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '24px',
    lineHeight: '29px',
    justifyContent: 'center',
    letterSpacing: '-0.5px',
    color: '#00D823', /* Green */
    paddingTop: '8px',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      marginTop: '3px',
      paddingTop: '0px'
    }
  },
  engagementNetworkTitle: {
    marginTop: '10px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.1px',
    /* Black */
    color: '#A7A9AC',
    [theme.breakpoints.between('md', 'md')]: {
      marginTop: '0px'
    }
  },
  engagementNetworkBackground: {
    /* AccentGray */
    background: '#F4F5F6',
    borderRadius: '5px',
    //width: '74px',
    //height: '66px',
    margin: '10px auto'
    // [theme.breakpoints.between('xs', 'sm')]: {
    //   width: '92px',
    //   height: '70px',
    //   marginTop: '14px',
    //   marginLeft: '25px'
    // },
    // [theme.breakpoints.between('md', 'md')]: {
    //   //width: '92px',
    //   height: '48px'
    // }
  },
  engagementNetworkDiv: {
    marginTop: '0px',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px'
    }
  },
  engagementDividerGrid: {
    maxWidth: '40px',
    [theme.breakpoints.between('xs', 'sm')]: {
      maxWidth: '100%'
    }
  },
  engagementDivider: {
    backgroundColor: '#F4F5F6',
    height: '115%',
    marginTop: '-30px',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '100%',
      height: '1px',
      marginTop: '15px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      width: '1px',
      height: '110%',
      marginTop: '-30px',
      marginLeft: '25px'
    }
  },
  networkGoldValue: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '48px',
    lineHeight: '58px',
    justifyContent: 'center',
    letterSpacing: '-0.5px',
    /* Gold */
    color: '#FFB800',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px',
      fontSize: '42px',
      lineHeight: '50px'
    }
  },
  networkGoldImage: {
    width: '40px',
    height: '40px',
    marginRight: '10px',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px',
      width: '30px',
      height: '35px'
    }
  },
  networkGoldText: {
    display: 'flex',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '20px',
    justifyContent: 'center',
    /* or 125% */
    letterSpacing: '0.1px',
    marginTop: '4px',
    //marginBottom: '10px',
    /* Gold */
    color: '#FFB800',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px',
      fontSize: '14px',
      lineHeight: '14px'
    }
  },
  networkGrayValue: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '24px',
    lineHeight: '29px',
    letterSpacing: '0.25px',
    justifyContent: 'center',
    /* Light Gray */
    color: '#A7A9AC',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px',
      fontSize: '21px',
      lineHeight: '25px'
    }
  },
  networkGrayImage: {
    width: '20px',
    height: '20px',
    marginRight: '4px',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px',
      width: '18px',
      height: '18px'
    }
  },
  networkGrayText: {
    display: 'flex',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    justifyContent: 'center',
    marginTop: '6px',
    /* or 100% */
    letterSpacing: '0.1px',
    /* Light Gray */
    color: '#A7A9AC',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px',
      fontSize: '14px',
      lineHeight: '14px'
    }
  },
  networkDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '1px'
    }
  },
  networkDivGold: {
    [theme.breakpoints.between('xs', 'sm')]: {
      height: '42px'
    }
  },
  ageChart: {
    // height: '120px'
  },
  demoGenderChart: {
    // margin: '0 auto',
    // height: '120px',
    paddingBottom: '15px',
    overflow: 'hidden',
    position: 'relative',
    flexWrap: 'unset',
    // width: '225px',
    [theme.breakpoints.between('xs', 'sm')]: {
      // width: '170px',
      // margin: '0 auto',
      paddingBottom: '10px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      // width: '150px',
      paddingBottom: '6px'
    }
  },
  demoGender: {
    display: 'flex',
    marginRight: '20px',
    marginLeft: '-5px',
    [theme.breakpoints.between('md', 'md')]: {
      marginRight: '2px',
      marginLeft: '-5px'
    }
  },
  demoGenderTitle: {
    width: '100%',
    marginTop: '4px',
    fontFamily: 'Uni Sans Regular',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: '#000000',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '14px',
      lineHeight: '14px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '14px',
      lineHeight: '14px',
      marginTop: '0px'
    }
  },
  demoGenderLegent: {
    marginTop: '10px',
    fontFamily: 'Uni Sans Regular',
    fontSize: '14px',
    lineHeight: '14px',
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '0.1px',
    color: '#808184',
    //marginTop: '20px',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px',
      justifyContent: 'center'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px'
    }
  },
  demoGenderLegentCircle: {
    borderRadius: '50%',
    width: '12px',
    height: '12px',
    marginRight: '5px',
    marginLeft: '5px'
  },
  demoGenderFemaleCircle: {
    backgroundColor: '#00B5EE' /* BlueHighlight */
  },
  demoGenderMaleCircle: {
    backgroundColor: '#4089FB' /* BlueHighlightDark */
  },
  demoDividerGrid: {
    maxWidth: '24px',
    [theme.breakpoints.between('xs', 'sm')]: {
      maxWidth: '100%'
    },
    [theme.breakpoints.between('md', 'md')]: {
      maxWidth: '12px',
      marginLeft: '4px'
    }
  },
  demoDivider: {
    backgroundColor: '#F4F5F6',
    height: '80%',
    marginTop: '15px',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '100%',
      height: '1px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      height: '65%',
      marginTop: '6px'
    }
  },
  genreProfileDivider: {
    backgroundColor: '#F4F5F6',
    height: '90%',
    marginTop: '10px',
    marginLeft: '24px',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '100%',
      height: '1px',
      marginTop: '0px'
    }
  },
  selectedGenreText: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.1px',
    color: '#000000',
    paddingLeft: '6px',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px'
    }
  },
  trackerSelectedGenreText: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: '#000000',
    paddingLeft: '6px',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px'
    }
  },
  selectedInfoText: {
    lineHeight: '16px',
    fontSize: '16px',
    letterSpacing: '0.1px',
    fontWeight: 300,
    color: '#000',
    fontStyle: 'normal',
    fontFamily: 'Uni Sans Light',
    marginLeft: '6px',
    marginTop: '4px',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px'
    }
  },

  portfolioTopNetworkChart: {
    justifyContent: 'center',
    // marginTop: '15px',
    display: 'flex',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px'
    }
  },
  portfolioTopNetworkTitle: {
    textAlign: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.1px',
    color: '#00B5EE', /* BlueHighlight */
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '11px'
    }
  },
  portfolioTopNetwork: {
    height: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    marginTop: '10px',
    [theme.breakpoints.between('md', 'md')]: {
      marginTop: '2px'
    }
  },
  portfolioArrow: {
    [theme.breakpoints.between('md', 'md')]: {
      width: '9px',
      height: '9px'
    }
  },
  portfolioTopContribution: {
    [theme.breakpoints.between('md', 'md')]: {
      marginTop: '2px'
    }
  },
  portfolioTop5NetworkTitle: {
    justifyContent: 'center',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.1px',
    color: '#0090A7', /* PrimaryTurq */
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '11px'
    }
  },
  portfolioTopImg: {
    width: '30px',
    height: '30px',
    marginRight: '6px',
    background: '#C4C4C4',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '18px',
      height: '18px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      width: '18px',
      height: '18px'
    }
  },
  portfolioDividerGrid: {
    maxWidth: '24px',
    [theme.breakpoints.between('xs', 'sm')]: {
      maxWidth: '100%'
    },
    [theme.breakpoints.between('md', 'md')]: {
      maxWidth: '20px',
      marginLeft: '4px'
    }
  },
  portfolioDemoDivider: {
    backgroundColor: '#F4F5F6',
    height: '80%',
    marginTop: '15px',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '100%',
      height: '1px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      height: '110%',
      marginTop: '-14px'
    }
  },
  portfolioTopContributeDiv: {
    [theme.breakpoints.between('xs', 'sm')]: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center'
    }
  },
  portfolioTopContribute: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.1px',
    marginTop: '10px',
    //marginBottom: '12px',
    color: '#0090A7', /* PrimaryTurq */
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px',
      marginTop: '3px',
      marginBottom: '3px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px',
      marginTop: '0px',
      marginBottom: '0px'
    }
  },
  portfolioTopOrderList: {
    display: 'contents',
    listStyle: 'none'
  },
  portfolioTopOrder: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.1px',
    marginRight: '3px',
    minWidth: '15px',
    display: 'inline-block',
    color: '#808184', /* DarkGray  */
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px'
    }
  },
  portfolioTopText: {
    //position: 'absolute',
    //display: 'inline-block',
    width: '180px',
    // overflow: 'hidden',
    // whiteSpace: 'nowrap',
    // textOverflow: 'ellipsis',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.1px',
    color: '#000000', /* Black  */
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px'
    }
  },
  root: {
    width: '100%'
  },
  container: {
    maxHeight: '150px',
    minHeight: '150px',
    [theme.breakpoints.between('xs', 'sm')]: {
      maxHeight: '100px',
      minHeight: '100px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      maxHeight: '100px',
      minHeight: '100px'
    }
  },
  trendingContainer: {
    maxHeight: '152px',
    minHeight: '152px',
    [theme.breakpoints.between('xs', 'sm')]: {
      maxHeight: '97px',
      minHeight: '97px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      maxHeight: '97px',
      minHeight: '97px'
    }
  },
  head: {
    backgroundColor: 'black',
    color: 'white'
  },
  topShowsImage: {
    width: 'auto',
    height: '30px',
    background: '#C4C4C4',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '18px',
      height: '18px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      width: '18px',
      height: '18px'
    }
  },
  topShowsFlame: {
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '10px',
      height: '15px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      width: '10px',
      height: '15px'
    }
  },
  topShowsArrow: {
    width: '18px',
    height: '14px',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '10px',
      height: '10px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      width: '14px',
      height: '10px'
    }
  },
  trendingVideosImage: {
    width: '64px',
    height: '36px',
    background: '#C4C4C4'
  },
  genreTopMentionedDiv: {
    width: '85%'
  },
  genreProfileText: {
    width: '80%'
  },
  genreProfileValue: {
    width: '20%'
  },
  genreTopMentionedTopText: {
    marginTop: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    paddingBottom: '6px',
    [theme.breakpoints.between('xs', 'sm')]: {
      justifyContent: 'center',
    display: 'flex'
    },
    [theme.breakpoints.between('md', 'md')]: {
      marginTop: '6px',
      paddingBottom: '3px'
    }
  },
  genreTopMentionedText: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.1px',
    color: '#808184'
  },
  genreTopMentionedValue: {
    marginLeft: '40px',
    alignItems: 'center',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '0.1px',
    color: '#808184'
  },
  anticipationType: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  anticipationArrow: {
    width: '22px',
    height: '22px',
    marginLeft: '15px',
    //marginRight: '6px',
    cursor: 'pointer',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '18px',
      height: '18px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      width: '18px',
      height: '18px',
      marginLeft: '15px'
      //marginRight: '15px'
    }
  },
  anticipationInfoImg: {
    marginTop: '-12px'
  },
  anticipationImageSpan: {
    width: '30px',
    height: '30px',
    background: '#C4C4C4',
    justifyContent: 'center',
    display: 'flex'
  },
  anticipationImage: {
    width: 'auto',
    height: '30px',
    background: '#C4C4C4'
  },
  genreInterestChartRow: {
    justifyContent: 'center',
    paddingTop: '18px'
  },
  genreInterestChart: {
    minWidth: '90%',
    paddingLeft: '12px',
    paddingRight: '0px',
    [theme.breakpoints.between('xs', 'sm')]: {
      paddingLeft: '0px'
    }
  },
  genreProfile: {
    display: 'flex',
    fontFamily: 'Uni Sans Regular',
    fontSize: '14px',
    lineHeight: '14px',
    alignItems: 'center',
    letterSpacing: '0.1px',
    color: '#808184',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px',
      justifyContent: 'center'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px'
    }
  },
  genreProfileList: {
    listStyle: 'none',
    padding: '0px',
    width: '100%',
    marginBottom: '0px',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '50%',
      marginTop: '0px',
      marginBottom: '0px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      width: '90%',
      marginTop: '0px',
      marginBottom: '0px'
    }
  },
  genreProfileChart: {
    margin: 'auto'
    //marginTop: '-6px'
  },
  genreProfileRadar: {
    marginTop: '4px',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '0px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      marginTop: '0px'
    }
  },
  viewership: {
    paddingTop: '24px !important',
    [theme.breakpoints.between('xs', 'sm')]: {
      paddingTop: '8px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      paddingTop: '0px'
    }
  },
  viewershipOverlap: {
    paddingTop: '24px !important',
    [theme.breakpoints.between('xs', 'sm')]: {
      paddingTop: '0px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      paddingTop: '0px',
      marginTop: '6px'
    }
  },
  viewershipDemoDivider: {
    backgroundColor: '#F4F5F6',
    height: '80%',
    marginTop: '15px',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '100%',
      height: '1px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      height: '75%',
      marginTop: '-13px'
    }
  },
  viewershipCircle: {
    borderRadius: '50%',
    width: '12px',
    height: '12px',
    marginRight: '6px',
    // marginLeft: '5px',
    display: 'block',
    flex: 'none'
  },
  viewershipNetworkTitle: {
    display: 'flex',
    fontFamily: 'Uni Sans Regular',
    fontSize: '14px',
    lineHeight: '14px',
    alignItems: 'center',
    letterSpacing: '0.1px',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px'
    }
  },
  viewershipNetwork: {
    display: 'flex',
    fontFamily: 'Uni Sans Regular',
    fontSize: '14px',
    lineHeight: '14px',
    alignItems: 'flex-start',
    letterSpacing: '0.1px',
    color: '#808184',
    marginTop: '8px',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px',
      marginTop: '3px'
    }
  },
  viewershipNetworkList: {
    listStyle: 'none',
    padding: '0px',
    width: '50%',
    marginBottom: '0px',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginBottom: '0px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      marginBottom: '0px'
    }
  },
  viewershipNetworkListPadding: {
    paddingLeft: '21px'
  },
  viewershipNetworkLists: {
    marginTop: '8px',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    [theme.breakpoints.between('md', 'md')]: {
      marginTop: '4px',
      marginBottom: '4px'
    }
  },
  viewershipNetworkListIndex: {
    marginRight: '6px'
  },
  viewershipNetworkListSpan: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  viewershipNetworkSpan: {
    marginRight: '21px'
  },
  viewershipCircle1: {
    backgroundColor: '#22DA4B'
  },
  viewershipCircle2: {
    backgroundColor: '#228DDA'
  },
  viewershipCircle3: {
    backgroundColor: '#E5750C'
  },
  viewershipCircle4: {
    backgroundColor: '#DA2222'
  },
  viewershipCircle5: {
    backgroundColor: '#DA22BC'
  },
  viewershipPagination: {
    justifyContent: 'center',
    display: 'flex',
    marginTop: '15px',
    [theme.breakpoints.between('xs', 'sm')]: {
      marginTop: '3px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      marginTop: '6px'
    }
  },
  viewershipPaginationPrev: {
    paddingRight: '21px',
    cursor: 'pointer'
  },
  viewershipPaginationNext: {
    paddingLeft: '21px',
    cursor: 'pointer'
  },
  cursorPointer: {
    cursor: 'pointer',
    textDecorationLine: 'underline'
  },
  newCalendar: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex'
  },
  whatsNewDefaultImageSpan: {
    width: '30px',
    height: '30px',
    background: '#808184',
    justifyContent: 'center',
    display: 'flex',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '18px',
      height: '18px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      width: '18px',
      height: '18px'
    }
  },
  whatsNewDefaultImage: {
    background: '#808184', //#C4C4C4
    width: 'auto',
    height: '30px',
    [theme.breakpoints.between('md', 'md')]: {
      width: 'auto',
      height: '18px'
    }
  },
  videoModal: {
    width: '35%',
    margin: 'auto',
    top: '25% !important',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: '80%',
      top: '35% !important'
    },
    [theme.breakpoints.between('md', 'md')]: {
      width: '35%',
      top: '25% !important'
    }
  },
  live: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  liveCircleSpan: {
    marginRight: '10px'
  },
  liveCircle: {
    display: 'flex',
    width: '32px',
    height: '32px'
  },
  liveText: {
    width: '47px',
    height: '22px',
    background: '#4089FB',
    borderRadius: '5px',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#FFFFFF'
  },
  completeText: {
    width: '98px',
    height: '22px',
    background: '#4089FB',
    borderRadius: '5px',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#FFFFFF'
  },
  dailyEngagementRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '0px !important'
  },
  dailyEngagementChartRow: {
    justifyContent: 'center',
    paddingTop: '14px',
    position: 'relative'
  },
  launchBar: {
    alignItems: 'center',
    display: 'flex'
  },
  teaserContainer: {
    maxHeight: '225px',
    minHeight: '225px',
    [theme.breakpoints.between('xs', 'sm')]: {
      maxHeight: '133px',
      minHeight: '133px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      maxHeight: '133px',
      minHeight: '133px'
    }
  },
  teaserNoDataText: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    /* or 100% */
    textAlign: 'center',
    letterSpacing: '0.1px',
    /* DarkGray */
    color: '#808184'
  },
  whatsNewContainer: {
    maxHeight: '215px',
    minHeight: '215px',
    [theme.breakpoints.between('xs', 'sm')]: {
      maxHeight: '133px',
      minHeight: '133px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      maxHeight: '133px',
      minHeight: '133px'
    }
  },
  wordCloudContainer: {
    maxHeight: '198px',
    minHeight: '198px',
    [theme.breakpoints.between('xs', 'sm')]: {
      maxHeight: '195px',
      minHeight: '195px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      maxHeight: '195px',
      minHeight: '195px'
    }
  },
  avgPerformer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '-60px'
  },
  avgText: {
    fontFamily: 'Uni Sans Regular',
    fontSize: '14px',
    lineHeight: '14px',
    alignItems: 'flex-start',
    letterSpacing: '0.1px',
    color: '#A7A9AC',
    display: 'block',
    width: '145px'
  },
  eventDisable: {
    pointerEvents: 'none'
  },
  pointer: {
    cursor: 'pointer'
  },
  audienceAcquisitionHeader: {
    marginTop: '12px'
  },
  newEngagerTitle: {
    display: 'flex',
    fontFamily: 'Uni Sans',
    fontSize: '16px',
    lineHeight: '20px',
    alignItems: 'center',
    letterSpacing: '0.1px',
    [theme.breakpoints.between('xs', 'sm')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: '12px'
    }
  },
  newEngagerCircle0: {
    backgroundColor: '#6372F2'
  },
  newEngagerCircle1: {
    backgroundColor: '#DE5F46'
  },
  newEngagerCircle2: {
    backgroundColor: '#5BC89A'
  },
  newEngagerCircle3: {
    backgroundColor: '#AD62FA'
  },
  newEngagerCircle4: {
    backgroundColor: '#FFA059'
  },
  newEngagerCircle5: {
    backgroundColor: '#61D1EF'
  },
  newEngagerCircle6: {
    backgroundColor: '#FF6693'
  },
  newEngagerCircle7: {
    backgroundColor: '#B6E77E'
  },
  newEngagerCircle8: {
    backgroundColor: '#FF96FD'
  },
  newEngagerCircle9: {
    backgroundColor: '#FBCB52'
  }
})